import {combineReducers} from 'redux'
import auth from './auth'
import conversation from './conversation'
import groupChannel from './groupChannel'

// import login from './loginReducer';
// import menu from './menuReducer';
// import profile from './profileReducer';
// import openChannel from './openChannelReducer';
// import openChannelCreate from './openChannelCreateReducer';
// import member from './memberReducer';
// import blockUser from './blockUserReducer';
// import groupChannel from './groupChannelReducer';
// import groupChannelInvite from './groupChannelInviteReducer';

export default combineReducers({
  auth,
  // channels,
  conversation,
  groupChannel
})
